var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-head',{ref:"header"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.keepAliveList}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_vm._v(" "),_c('v-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61cb3351","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/index.vue
// module id = null
// module chunks = 